"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toolbarSplitButtonTheme = exports.toolbarSeparatorTheme = exports.toolbarPaddingTheme = exports.toolbarOverflowTheme = exports.toolbarFontTheme = exports.toolbarButtonTextColorTheme = exports.toolbarButtonFocusRingTheme = exports.toolbarButtonBackgroundTheme = exports.getToolbarDropdownArrowIconTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
var _spacing = require("../../../constants/spacing");
// In Lodestar, we need these backgrounds to be white w/ the secondary button treatment + focusLightX hover colors.
// In Ursa, we need to allow the toolbar to exist on Canvas and on the Work surface. Both have different button treatments.
const toolbarButtonBackgroundTheme = (0, _sdsThemeInternal.themed)({
  // This style is only used in Ursa.
  canvas: {
    normal: {
      rest: "transparent",
      hover: {
        "lodestar-light": _designTokens.lodestarColors.buttonDefault,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--slate--weaker")
      },
      active: (0, _designTokensReact.color)("color--background--slate--default"),
      focus: "transparent",
      disabled: "transparent"
    },
    checked: {
      rest: {
        "lodestar-light": _designTokens.lodestarColors.focusLight10,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest")
      },
      hover: {
        "lodestar-light": _designTokens.lodestarColors.focusLight20,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weaker")
      },
      active: {
        "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default"),
        "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-blue--weak")
      },
      focus: {
        "lodestar-light": _designTokens.lodestarColors.focusLight10,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest")
      },
      disabled: {
        "lodestar-light": "transparent",
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest")
      }
    }
  },
  "work-surface": {
    normal: {
      rest: "transparent",
      hover: {
        "lodestar-light": _designTokens.lodestarColors.buttonDefault,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--slate--weaker")
      },
      active: (0, _designTokensReact.color)("color--background--slate--default"),
      focus: "transparent",
      disabled: "transparent"
    },
    checked: {
      rest: {
        "lodestar-light": _designTokens.lodestarColors.focusLight10,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest")
      },
      hover: {
        "lodestar-light": _designTokens.lodestarColors.focusLight20,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weaker")
      },
      active: {
        "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default"),
        "ursa-light": (0, _designTokensReact.color)("color--background--spectrum-blue--weak")
      },
      focus: {
        "lodestar-light": _designTokens.lodestarColors.focusLight10,
        // no semantic token
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest")
      },
      disabled: {
        "lodestar-light": "transparent",
        "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest")
      }
    }
  }
});
exports.toolbarButtonBackgroundTheme = toolbarButtonBackgroundTheme;
const toolbarButtonTextColorTheme = (0, _sdsThemeInternal.themed)({
  canvas: {
    checked: {
      rest: (0, _designTokensReact.color)("color--text--primary--default"),
      disabled: (0, _designTokensReact.color)("color--text--primary--weak")
    },
    normal: {
      rest: (0, _designTokensReact.color)("color--text--slate--default"),
      disabled: (0, _designTokensReact.color)("color--text--slate--weaker")
    }
  },
  // This style supports both Lodestar and Ursa.
  "work-surface": {
    checked: {
      rest: (0, _designTokensReact.color)("color--text--primary--default"),
      disabled: (0, _designTokensReact.color)("color--text--primary--weak")
    },
    normal: {
      rest: (0, _designTokensReact.color)("color--text--neutral--default"),
      disabled: (0, _designTokensReact.color)("color--text--neutral--weaker")
    }
  }
});
exports.toolbarButtonTextColorTheme = toolbarButtonTextColorTheme;
const toolbarButtonFocusRingTheme = (0, _sdsThemeInternal.themed)({
  borderRadius: {
    "lodestar-light": 4,
    "ursa-light": 8
  },
  offset: {
    "lodestar-light": 2,
    "ursa-light": 0
  }
});
exports.toolbarButtonFocusRingTheme = toolbarButtonFocusRingTheme;
const toolbarFontTheme = (0, _sdsThemeInternal.themed)({
  variant: {
    "lodestar-light": "bodyText",
    "ursa-light": "TT-Norms-Pro--14px--500w"
  }
});
exports.toolbarFontTheme = toolbarFontTheme;
const toolbarSeparatorTheme = (0, _sdsThemeInternal.themed)({
  color: {
    canvas: {
      "lodestar-light": _designTokens.lodestarColors.neutralLight10,
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--border--slate--weaker")
    },
    "work-surface": {
      "lodestar-light": _designTokens.lodestarColors.neutralLight10,
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weaker")
    }
  },
  margin: {
    "lodestar-light": `0 ${_spacing.sizes.xSmall}px 0 ${_spacing.sizes.xxSmall}px`,
    "ursa-light": `0 ${_designTokens.space.space20}`
  },
  width: {
    "lodestar-light": "2px",
    "ursa-light": "1px"
  },
  height: {
    "lodestar-light": "100%",
    "ursa-light": "14px"
  }
});

// These should all add up properly to make sure a ToolbarButton's elements are properly spaced
// internally.
exports.toolbarSeparatorTheme = toolbarSeparatorTheme;
const toolbarPaddingTheme = (0, _sdsThemeInternal.themed)({
  buttonPadding: {
    "lodestar-light": "0 4px 0 6px",
    "ursa-light": "0 8px 0 8px"
  },
  textPadding: {
    "lodestar-light": "0 4px 0 2px",
    "ursa-light": "0 4px 0 0 "
  },
  iconPadding: {
    "lodestar-light": "0 0 0 2px",
    "ursa-light": "0 0 0 0"
  },
  leftSplitButtonPadding: {
    "lodestar-light": "0 4px 0 6px",
    "ursa-light": "0 4px 0 8px"
  },
  rightSplitButtonPadding: {
    "lodestar-light": "0",
    "ursa-light": "0 4px"
  }
});
exports.toolbarPaddingTheme = toolbarPaddingTheme;
const toolbarSplitButtonTheme = (0, _sdsThemeInternal.themed)({
  gap: {
    "lodestar-light": "1px",
    "ursa-light": 0
  }
});
exports.toolbarSplitButtonTheme = toolbarSplitButtonTheme;
const toolbarOverflowTheme = (0, _sdsThemeInternal.themed)({
  boxShadow: {
    "lodestar-light": "0px 2px 12px 0px rgba(0, 0, 0, 0.16)",
    "ursa-light": (0, _designTokensReact.color)("elevation--shadow-2")
  },
  borderRadius: {
    "lodestar-light": "2px",
    "ursa-light": "4px"
  }
});
exports.toolbarOverflowTheme = toolbarOverflowTheme;
const getToolbarDropdownArrowIconTheme = themeMode => {
  switch (themeMode) {
    case "lodestar-light":
    case "oldestar":
      return /*#__PURE__*/_react.default.createElement(_lodestarIcons.ArrowDownIcon, {
        size: "small"
      });
    case "ursa-light":
    case "ursa-dark":
    default:
      return /*#__PURE__*/_react.default.createElement(_ursaIcons.ChevronDownIcon, {
        size: 16,
        color: "currentColor"
      });
  }
};
exports.getToolbarDropdownArrowIconTheme = getToolbarDropdownArrowIconTheme;
//# sourceMappingURL=toolbarTheme.js.map